/**
 * Returns the first element of given array
 * @param x
 * @returns
 */
export const firstElement = <T>(x: T[]) => (x.length > 0 ? x[0] : null);
